import Table from '@/common/components/Table';
import React, { useContext } from 'react';
import { HEADERS } from './constants/headers';
import { useNavigate } from 'react-router-dom';
import { getRaws } from './helpers/getRaws';
import { AuthContext } from '@/common/contexts/authContext';

const TicketsSearchTable = ({ dataToDisplay, setMessages }) => {
	const navigate = useNavigate();
	const { authUser } = useContext(AuthContext);

	return (
		<Table
			style={{ margin: '0 auto' }}
			className='styled-table'
			headers={HEADERS}
			raws={getRaws(dataToDisplay, navigate, setMessages, authUser.id)}
		/>
	);
};

export default TicketsSearchTable;
